<template>
  <section class="statement-section">
    <div class="statement-section__header">
      <div class="statement-section__marker">5</div>
      <div>
        <h3 class="statement-section__title">Дополнительная информация</h3>
        <p class="statement-section__description">
          Целевое направление, общежитие и особые условия поступления
        </p>
      </div>
    </div>

    <div class="statement-info-grid">
      <div class="statement-info-row">
        <div class="statement-info-row__text">
          <div class="statement-info-row__title">Поступаете по целевому направлению?</div>
          <div class="statement-info-row__description">Выберите направляющую организацию</div>
        </div>
        <v-autocomplete autocomplete="one-time-code"
          v-model="formData.targetOrganizationId"
          :items="$model.targets"
          item-title="name"
          item-value="id"
          variant="outlined"
          density="comfortable"
          label="Направляющая организация"
          clearable
          hide-details="auto"
        />
      </div>

      <div class="statement-info-row">
        <div class="statement-info-row__text">
          <div class="statement-info-row__title">Поступление на пополнение в группы</div>
          <div class="statement-info-row__description">
            Для студентов на базе 11 классов, поступающих на очное отделение
          </div>
        </div>
        <v-checkbox v-model="formData.isGroupReplenishment" label="Да" hide-details />
      </div>

      <div class="statement-info-row">
        <div class="statement-info-row__text">
          <div class="statement-info-row__title">Нуждаетесь ли в общежитии?</div>
        </div>
        <v-select autocomplete="one-time-code"
          v-model="formData.dormitoryNeed"
          :items="dormitoryNeedOptions"
          item-title="label"
          item-value="value"
          variant="outlined"
          density="comfortable"
          label="Выберите вариант"
          clearable
          hide-details="auto"
        />
      </div>

      <div class="statement-info-row statement-info-row--wide">
        <div class="statement-info-row__text">
          <div class="statement-info-row__title">Льготные категории абитуриентов</div>
        </div>
        <div class="statement-checkbox-list">
          <v-checkbox
            v-for="privilege in $model.privilege"
            :key="privilege.id"
            v-model="formData.privileges"
            :label="privilege.name"
            :value="privilege.id"
            density="comfortable"
            hide-details
          />
        </div>
      </div>

      <div class="statement-info-row">
        <div class="statement-info-row__text">
          <div class="statement-info-row__title">Изучаемые иностранные языки</div>
        </div>
        <v-autocomplete autocomplete="one-time-code"
          v-model="formData.schoolLanguages"
          :items="$model.schoolLanguages"
          item-title="name"
          item-value="id"
          variant="outlined"
          density="comfortable"
          label="Выберите языки"
          multiple
          chips
          closable-chips
          clearable
          hide-details="auto"
        />
      </div>

      <div class="statement-info-row">
        <div class="statement-info-row__text">
          <div class="statement-info-row__title">Место работы (если имеется)</div>
        </div>
        <v-text-field autocomplete="one-time-code"
          v-model="formData.workPlace"
          variant="outlined"
          density="comfortable"
          hide-details="auto"
        />
      </div>

      <div class="statement-info-row">
        <div class="statement-info-row__text">
          <div class="statement-info-row__title">Должность</div>
        </div>
        <v-text-field autocomplete="one-time-code"
          v-model="formData.position"
          variant="outlined"
          density="comfortable"
          hide-details="auto"
        />
      </div>

      <div class="statement-info-row">
        <div class="statement-info-row__text">
          <div class="statement-info-row__title">Стаж</div>
        </div>
        <v-text-field autocomplete="one-time-code"
          v-model="formData.experience"
          variant="outlined"
          density="comfortable"
          hide-details="auto"
        />
      </div>

      <div class="statement-info-row">
        <div class="statement-info-row__text">
          <div class="statement-info-row__title">Военкомат</div>
        </div>
        <v-autocomplete autocomplete="one-time-code"
          v-model="formData.militaryOfficeId"
          :items="$model.militaryOffice"
          item-title="name"
          item-value="id"
          variant="outlined"
          density="comfortable"
          clearable
          hide-details="auto"
        />
      </div>

      <div class="statement-info-row statement-info-row--wide">
        <div class="statement-info-row__text">
          <div class="statement-info-row__description">
            Если в списке нет нужного военкомата, то укажите его в поле ниже или пропустите данный пункт
          </div>
        </div>
        <v-text-field autocomplete="one-time-code"
          v-model="formData.militaryOffice"
          variant="outlined"
          density="comfortable"
          hide-details="auto"
        />
      </div>

      <div class="statement-info-row statement-info-row--wide">
        <div class="statement-info-row__text">
          <div class="statement-info-row__title">Примечания</div>
        </div>
        <v-textarea autocomplete="one-time-code"
          v-model="formData.notes"
          rows="3"
          variant="outlined"
          density="comfortable"
          hint="Укажите здесь в свободной форме любые необходимые сведения, не указанные в других частях анкеты, информацию о спортивных разрядах, участии в творческих коллективах, областных олимпиадах и т.д."
          persistent-hint
        />
      </div>

      <div v-if="$model.isStaff" class="statement-info-row statement-info-row--wide">
        <div class="statement-info-row__text">
          <div class="statement-info-row__title">Комментарий оператора приемной комиссии к заявлению</div>
        </div>
        <v-textarea autocomplete="one-time-code"
          v-model="formData.operatorComment"
          rows="3"
          variant="outlined"
          density="comfortable"
        />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AdditionalSection',
  props: {
    formData: {
      type: Object,
      required: true
    },
    dormitoryNeedOptions: {
      type: Array,
      required: true
    }
  }
}
</script>

<style>
.statement-info-grid {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.statement-info-row {
  display: grid;
  grid-template-columns: minmax(220px, 0.85fr) minmax(260px, 1.15fr);
  gap: 16px;
  align-items: start;
  padding-bottom: 12px;
  border-bottom: 1px solid #e6e8ee;
}

.statement-info-row:last-child {
  padding-bottom: 0;
  border-bottom: 0;
}

.statement-info-row--wide {
  align-items: start;
}

.statement-info-row__text {
  min-width: 0;
  padding-top: 8px;
}

.statement-info-row__title {
  font-weight: 700;
  line-height: 1.35;
  color: #1f2937;
}

.statement-info-row__description {
  margin-top: 4px;
  color: #667085;
  line-height: 1.4;
}

.statement-checkbox-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

@media (max-width: 640px) {
  .statement-info-row {
    grid-template-columns: minmax(0, 1fr);
  }

  .statement-info-row__text {
    padding-top: 0;
  }
}
</style>
